import BaseModelAPI from '../BaseModelAPI';

export default class MappingAndonProduction extends BaseModelAPI {
	static entity = 'mappingandonproduction';
	static entityName = 'mappingandonproduction';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.andonName = '';
			this.mappingAndonProdDetail = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}